<template>
  <div class="container-fluid navigation-bar p-1 px-2">
    <button @click="toggle" class="burger">
      <font-awesome-icon icon="fa-solid fa-bars" />
    </button>

    <div class="navbar-logo"></div>
    <div class="navigation-box">
    </div>

    <div class="user-settings my-2">
      <button @click="syncData" class="burger">
        <font-awesome-icon icon="fa-solid fa-arrows-rotate" />
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import { utils } from '@/Services/utils';

/**
 * Top navigation bar with drawer toggle and page reload action.
 */
export default defineComponent({
  name: 'NavigationBar',
  props: {
    toggle: {
      type: Function as PropType<() => void>,
      required: true,
    },
  },
  /**
   * NavigationBar setup — exposes sync/reload handler.
   */
  setup() {
    /** Reloads the current page after showing the global loader. */
    function syncData(): void {
      utils.showLoading();
      window.location.reload();
    }

    return { syncData };
  },
});
</script>

<style lang="scss" scoped>
.burger {
  background: transparent;
  color: white;
  font-size: 24px;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  &:hover { background: rgba(255,255,255,0.15); }
}

.user-settings {
  display: flex;
  flex-direction: row;
  justify-content: end;
}

.navigation-bar {
  display: flex;
  background: linear-gradient(135deg, var(--ct-primary-dark) 0%, var(--ct-primary) 100%);
  justify-content: space-between;
  align-items: center;
  min-height: 56px;
  max-height: 56px;
  padding: 0 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.12);
  .navbar-logo { flex: 1; }
  .navigation-box { flex: 2; }
  .user-settings { flex: 1; }
}
</style>